import React, { useState } from 'react';
import Image from 'next/image';
import SectionHeading from '../../Common/SectionHeading';
import Link from 'next/link';

const TabSection = ({data=null, title}) => {
    const [activeTab, setActiveTab] = useState(0);

    const handleTabClick = (index) => {
        setActiveTab(index);
    };

    return (
        <>
            {(data) &&
                <>
                    <div className="flex flex-col justify-center w-11/12 mx-auto my-6 xl:max-w-screen max-w-screen-2xl lg:my-10">
                        <SectionHeading
                            title={title}
                            
                        />
                        <ul className="flex flex-col px-0 text-center list-none bg-blue-200 bg-opacity-25 tabs md:flex-row xl:flex-wrap xl:justify-between xl:-ms-flex-wrap-wrap mb-30 active">
                            {data?.map((item, index) => (
                                <li
                                    key={index}
                                    className={index === activeTab ? 'text-sm text-white current text-center flex list-none justify-center items-center px-4 py-2 cursor-pointer xl:whitespace-nowrap bg-gradient-to-tr from-blue-600 to-blue-200 hover:bg-gradient-to-r hover:from-blue-500 hover:via-blue-400 hover:to-blue-300 transition-transform duration-500' : 'text-sm text-black text-center flex list-none transition-transform duration-500 justify-center items-center px-4 py-2 cursor-pointer xl:whitespace-nowrap'}
                                    onClick={() => handleTabClick(index)}
                                >
                                    <button
                                        className='relative z-10 block py-2 overflow-hidden text-base font-semibold text-gray-800 transition-transform duration-500 rounded-md'
                                        type="button"
                                    >
                                        <span className={index === activeTab ? 'text-white flex mt-0 flex-col justify-center' : 'flex mt-0 flex-col justify-center'}>
                                            {item?.title}
                                        </span>
                                    </button>
                                </li>
                            ))}
                        </ul>
                        <div className="tabContent">
                            {data?.map((item, index) => (
                                <div
                                    key={index}
                                    className={`tabItem ${index === activeTab ? '' : 'hidden'}`}
                                >
                                    <div className="grid grid-cols-12 gap-4">
                                        <div className="col-span-12 md:col-span-6">
                                            <p className='pt-1 md:pt-2'>{item?.description}</p>
                                            {item?.points.map((point, pointIndex) => (
                                                <div key={pointIndex}>
                                                    <h3 className='flex items-center text-lg font-semibold'> <i className="fa fa-circle text-xs pr-2 text-[#1b5df3]"></i> {point.title}</h3>
                                                    <p>{point.description}</p>
                                                </div>
                                            ))}
                                        </div>
                                        <div className="col-span-12 md:col-span-6">
                                            <Image priority={false} alt={item?.altText ? item?.altText : item?.title ? item?.title : 'DelveInsight'} className="w-full h-full pt-5 md:pt-10" width={2000} height={2000} src={process.env.IMG_CDN+item?.imageSrc} />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </>
            }
        </>
    );
};

export default TabSection;
